var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topNav',{on:{"listenClassify":_vm.getClassfiy}}),_vm._v(" "),_c('banner'),_vm._v(" "),_c('mune'),_vm._v(" "),_c('specialArea'),_vm._v(" "),_c('couponGoodsList',{ref:"offsetTopEle",attrs:{"parentCat":_vm.parentCat}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539558ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodsCoupon/goodsCoupon.vue
// module id = null
// module chunks = 